<template>
<layout-content>
  <template #toolbar>
    <section class="toolbar-btn">
      <el-radio-group v-model="query.sourceType" size="small" @change="getList">
        <el-radio-button
          v-for="sourceType in sourceTypes"
          :key="sourceType.value"
          :label="sourceType.value"
        >{{sourceType.label}}</el-radio-button>
      </el-radio-group>

      <el-button
        type="orange"
        icon="el-icon-plus"
        size="small"
        @click="onOpenEditor()"
      >新建{{editName}}</el-button>
    </section>
  </template>

  <template #body>
    <data-wrapper>
      <el-table
        ref="table"
        :data="list"
        height="100%"
        border
        stripe
        highlight-current-row
        header-row-class-name="custom-table-header"
        class="custom-table no-inner-border"
        style="width: 100%"
        @selection-change="onSelectionChange"
        @row-click="onOpenEditor"
      >
        <el-table-column prop="id" label="污染源id" />
        <el-table-column prop="name" label="污染源名称" />
        <el-table-column label="污染源颜色">
          <template slot-scope="{row}">
            <div class="color-section" :style="{
              'background-color': row.color
            }"></div>
          </template>
        </el-table-column>
        <el-table-column prop="note" label="污染源备注" />
        <el-table-column label="操作" align="center">
          <template slot-scope="{row}">
            <div class="table-operator-wrapper">
                <span class="table-operator-btn delete-btn" @click.stop="onShowDeleteConfirmDialog(row)">
                  <i class="el-icon-delete" aria-hidden="true"></i>
                </span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </data-wrapper>
  </template>

  <template #editor>
    <editor
      ref="editor"
      :source-type="query.sourceType"
      @save="getList"
      @close="onCancelHighlightTableRow"
    />
  </template>
</layout-content>
</template>

<script>
import BaseListEditor from '../../../BaseListEditor'

import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import Editor from './Editor'

const sourceTypes = [{
  value: 0,
  label: '颗粒物'
}, {
  value: 1,
  label: 'VOCs'
}]

export default {
  name: 'SystemConfigPollutantSource',
  routeInfo: {
    label: '污染来源维护',
    icon: 'fa fa-database',
    curdInfo: {
      api: 'PMFPollutantSource',
      id: 'id',
      name: 'name',
      editName: '污染来源'
    }
  },
  extends: BaseListEditor,
  components: {LayoutContent, DataWrapper, Editor},
  data: () => ({
    query: {
      sourceType: sourceTypes[0].value
    }
  }),
  computed: {
    sourceTypes: () => sourceTypes
  },
  methods: {

  },
  created () {
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.color-section {
  width: 20px;
  height: 20px;
}
</style>



// WEBPACK FOOTER //
// src/views/09System-Settings/04Config/10PollutantSouce/index.vue